import {
  Box,
  Button,
  Flex,
  FormLabel,
  Input,
  Link,
  VStack,
} from '@chakra-ui/core';
import crypto from 'crypto';
import { utils } from 'eciesjs';
import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useAppDispatch } from '../store';
import { setMnemonic } from '../store/wallet/walletSlice';
import keystore from '../utils/Keystore';
interface Props {
  onNext: () => void;
  onBack?: () => void;
  showBack?: boolean;
}

const WalletUnlock = ({ onNext, showBack, onBack }: Props) => {
  const [password, setPassword] = useState('');
  const dispatch = useAppDispatch();
  const [error, setError] = useState(false);

  const validateInput = () => {
    let errored = false;

    if (!password) {
      setError(true);
      errored = true;
    }

    return !errored;
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleDecrypt();
    }
  };

  const handleDecrypt = () => {
    if (!validateInput()) return;

    try {
      const passwordKey = crypto.createHash('sha256').update(password).digest();
      const encryptedMnemonic = window.localStorage.getItem(
        'encryptedMnemonic'
      );

      const mnemonic = utils
        .aesDecrypt(passwordKey, Buffer.from(encryptedMnemonic!, 'base64'))
        .toString('utf8');

      keystore.set('mnemonic', mnemonic);
      dispatch(setMnemonic(mnemonic));

      onNext();
    } catch (e) {
      setError(true);
      console.error(e);
    }
  };

  return (
    <>
      <VStack spacing={2} alignItems="flex-start">
        <Box>
          <FormLabel fontSize="lg">Unlock Wallet</FormLabel>
          <Input
            placeholder="Enter Password Here"
            type="password"
            value={password}
            isInvalid={error}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={handleKeyDown}
          />
        </Box>

        <Link
          fontSize="xs"
          as={RouterLink}
          to="/recover"
          color="blue.600"
          textDecor="underline"
        >
          Recover using seed phrase
        </Link>
      </VStack>

      <Flex mt="1.25em">
        {showBack && (
          <Button backgroundColor="#d8d8d8" color="#4aa4a4a" onClick={onBack}>
            Previous Step
          </Button>
        )}

        <Button
          ml="auto"
          colorScheme="blue"
          color="white"
          onClick={() => handleDecrypt()}
        >
          Unlock Wallet
        </Button>
      </Flex>
    </>
  );
};

export default WalletUnlock;
